import { render, staticRenderFns } from "./table-assigned.vue?vue&type=template&id=5f2f0f25"
import script from "./table-assigned.vue?vue&type=script&lang=js"
export * from "./table-assigned.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports